import { RouteType } from "../types/App";
import { getReserveWithGoogleToken } from "./getReserveWithGoogleToken";
import { parseRoute } from "./routeUtils";

export const getWidgetOrigin = (clientKey: string): string => {
  const devEnv = process.env.REACT_APP_DEV_ENV || false;
  const protocol = process.env.REACT_APP_WIDGET_URL_PROTOCOL || "";
  const url = process.env.REACT_APP_WIDGET_URL || "";

  if (devEnv) {
    return protocol + url;
  } else {
    return protocol + clientKey + url;
  }
};

export const getWidgetUrl = (
  rwgConfig:
    | {
        clientKey: string;
        flowKey: string;
      }
    | {
        schedulerSrc: string;
        gbpName?: string;
      }
): string => {
  const routeParams = parseRoute();

  if ("schedulerSrc" in rwgConfig) {
    const url = new URL(rwgConfig.schedulerSrc);

    url.searchParams.set("client_url", window.location.toString());

    if (routeParams.type === RouteType.AbandonedSession) {
      url.searchParams.set(
        "client_url",
        window.location.toString() + `?absid=${routeParams.abandonedSessionId}`
      );
    } else if (routeParams.type === RouteType.Yelp) {
      const clientUrl = new URL(window.location.toString());
      clientUrl.searchParams.set("utm_source", "yelp");
      url.searchParams.set("client_url", clientUrl.toString());

      if (routeParams.yelpToken) {
        url.searchParams.set("yelp_tracking_id", routeParams.yelpToken);
      }

      // Forward along any other query params Yelp includes without
      // clobbering the ones already set above, re-adding yelp_token
      // under its raw name, or duplicating utm_source at the top
      // level (it belongs on client_url only).
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (
          key !== "yelp_token" &&
          key !== "utm_source" &&
          !url.searchParams.has(key)
        ) {
          url.searchParams.set(key, value);
        }
      });
    } else {
      url.searchParams.set("client_url", window.location.toString());

      if (!routeParams.isGbpId) {
        url.searchParams.set("schedulerToken", routeParams.token);
      }

      const rwgToken = getReserveWithGoogleToken();

      if (rwgToken) {
        url.searchParams.set("rwgToken", rwgToken);
      }
    }

    url.searchParams.set("client_referrer", document.referrer);

    if (rwgConfig.gbpName) {
      url.searchParams.set("gbpName", rwgConfig.gbpName);
    }

    return url.toString();
  }

  const { clientKey, flowKey } = rwgConfig;

  const data = {
    api_key: clientKey,
    widget_view_mode: "page",
  };

  const searchParams = new URLSearchParams(data);

  if (flowKey) {
    searchParams.append("flow_key", flowKey);
  }

  const rwgToken = getReserveWithGoogleToken();

  if (rwgToken) {
    searchParams.set("rwg_token", rwgToken);
  }

  return `${getWidgetOrigin(clientKey)}/?${searchParams.toString()}`;
};
